import React from 'react'
import { compose } from 'recompose'
import { injectIntl } from 'react-intl'
import Grid from '@material-ui/core/Grid'
import { Button, Typography } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { hideModal } from '../../../../redux/actions'

const InstructionModal = ({ intl, title, text }) => {
	const dispatch = useDispatch()

	return (
			<Grid
				container
				direction="column"
			>
				<Grid item style={{ width: '100%', backgroundColor: '#e6f2ff' }}>
					<Typography
						variant="h4"
						style={{ padding: '32px 12px', margin: '0' }}
					>
						{title}
					</Typography>
				</Grid>

				<Grid item style={{ width: '100%' }}>
				<Typography
						variant="body1"
						style={{ padding: '32px 12px ', fontStyle: 'italic' }}
					>
						<span dangerouslySetInnerHTML={{ __html:text }} />
					</Typography>
				</Grid>
				<Grid
					item
					style={{
						width: '100%',
						padding: '0 12px 32px 12px',
						textAlign: 'center'
					}}
				>
                    <Button
                        variant="contained"
                        color="primary"
						style={{
							width: '200px'
						}}
						type="submit"
						size="large"
						onClick={() => (dispatch(hideModal()))}
					>
						{intl.formatMessage({ id: 'app.general.closeModalLabel' })}
					</Button>
				</Grid>
			</Grid>
	)
}


const enhance = compose(injectIntl)

export default enhance(InstructionModal)
